import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import {
  Box,
  Flex,
  useToast
} from "@chakra-ui/react";
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import { createDsrWithTemplate, resetCreateDsrWithTemplateOutcome } from '../actions/dsr-template-actions';
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import { MdAutoDelete } from "react-icons/md";
import { MdForkRight } from "react-icons/md";
import { redirectToNewPage, triggerLaunchdeckToast } from '../../global/helpers/global-helpers';
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';


function ConfirmCreateDsrFromTemplateModal({
  handleCloseModal,
  modalTransferPayload,
  createDsrWithTemplate,
  resetCreateDsrWithTemplateOutcome,
  createDsrWithTemplateOutcome,
  isMobileView,
  dsrTemplateId
}) {

  const toast = useToast();

  // UX Management
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {
    if (createDsrWithTemplateOutcome) {

      const { dsrCreatedSuccessfully, processedEvent, redirectionPath } = createDsrWithTemplateOutcome || {};
      if (processedEvent === "create-dsr-with-template") {
        if (dsrCreatedSuccessfully === true) {
          toast(
            triggerLaunchdeckToast({
              useCase: "show-success-state",
              label: "A new Room has been successfully created",
              isMobileView
            })
          )

          redirectionPath ? redirectToNewPage(redirectionPath) : handleCloseModal()
        } else {
          toast(
            triggerLaunchdeckToast({
              useCase: "show-error-state",
              label: "Unfortunately something went wrong. Please try again later.",
              isMobileView
            })
          )

          setShowLoader(false);
        }
      }

      resetCreateDsrWithTemplateOutcome()
    }

  }, [createDsrWithTemplateOutcome, handleCloseModal]);

  const handleConfirmCreateDsrWithTemplateButton = () => {

    if (dsrTemplateId) {
      setShowLoader(true);

      createDsrWithTemplate({
        sourceEvent: "create-dsr-with-template",
        sourceDsrTemplateId: dsrTemplateId
      })
    }

  }


  function displayContent() {
    if (showLoader) {
      return (
        <Box w="100%" align="center" >
          <Box px='1em'>
            <PageLoader />
          </Box>
        </Box>
      )
    }

    if (!showLoader) {
      return (
        <Box w='100%' p='1em 1.8em'>
          <Flex w="100%" direction='column' gap='1em' fontSize='0.875em' color='brandDark.500'>
            <Box>
              You will become the owner of this newly created Room, and all the content inside it.
            </Box>
            <Box>
              Go ahead?
            </Box>
          </Flex>

          <Flex mt='1.625em' w='100%' justify={['center', 'flex-end']}>
            <LaunchdeckButton bg='brand.500' w={['100%', 'auto']} color='gray.50' fontSize='0.8em' py='0.4em' onClick={() => handleConfirmCreateDsrWithTemplateButton()} label='Yes, create Room' />
          </Flex>
        </Box>
      )
    }
  }

  return (
    <LaunchdeckModal
      title={
        <Flex align='center' gap='0.5em'>
          <Box as={showLoader ? MdAutoDelete : MdForkRight} color='brand.500'
            boxSize="1.6em" />
          {showLoader ?
            <Box py='0.5em' color='white'>Creating the new Room ...</Box>
            :
            <Box px='0.5em' py='0.5em' fontWeight='600' color='white'>Create new Room with <i>{modalTransferPayload.dsrTitle}</i> template</Box>
          }
        </Flex>
      }
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}

function mapStateToProps(state) {
  return {
    dsrTemplateId: state.dsrTemplateId.results,
    createDsrWithTemplateOutcome: state.createDsrWithTemplateOutcome.results.data,
    isMobileView: state.mobileViewMode.isMobileView
  };
}


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createDsrWithTemplate,
      resetCreateDsrWithTemplateOutcome
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfirmCreateDsrFromTemplateModal));
